{
  "title": "Configuración",
  "panel": {
    "createTitle": "Crear {{title}}",
    "updateTitle": "Actualizar {{title}}",
    "createDescription": "Crear {{title}}.",
    "updateDescription": "Actualizar {{title}}.",
    "removeTitle": "Eliminar {{title}}",
    "removeText": "¿Estás seguro de que quieres eliminar este {{title}}? Esta acción no se puede deshacer.",
    "closePanel": "Cerrar panel",
    "remove": "Eliminar",
    "test": "Probar",
    "ok": "¡OK!",
    "error": "ERROR",
    "cancel": "Cancelar",
    "create": "Crear",
    "save": "Guardar"
  },
  "nav": {
    "application": "Aplicación",
    "logs": "Registros",
    "indexers": "Indexadores",
    "irc": "IRC",
    "feeds": "Feeds",
    "lists": "Listas",
    "clients": "Clientes",
    "notifications": "Notificaciones",
    "apiKeys": "Claves API",
    "proxies": "Proxies",
    "releases": "Lanzamientos",
    "account": "Cuenta"
  },
  "application": {
    "title": "Aplicación",
    "description": "Configuración de la aplicación. Cambia en config.toml y reinicia para que surta efecto.",
    "host": "Host",
    "port": "Puerto",
    "baseUrl": "URL base",
    "version": "Versión",
    "commit": "Commit",
    "buildDate": "Fecha de compilación",
    "application": "Aplicación",
    "configPath": "Ruta de configuración",
    "database": "Base de datos",
    "webuiDebugMode": "Modo de depuración de WebUI",
    "checkForUpdates": "Buscar actualizaciones",
    "checkForUpdatesDescription": "Recibir notificaciones de nuevas actualizaciones.",
    "theme": "Tema",
    "themeDescription": "Elige entre tema claro, oscuro o seguir el sistema.",
    "languageDescription": "Elige el idioma usado en la WebUI.",
    "updateEnabled": "Ahora recibirás notificaciones de nuevas actualizaciones.",
    "updateDisabled": "Ya no recibirás notificaciones de nuevas actualizaciones.",
    "updateAvailable": "¡{{name}} disponible!"
  },
  "account": {
    "title": "Cuenta",
    "description": "Administrar configuración de la cuenta.",
    "required": "Obligatorio",
    "passwordsDoNotMatch": "¡Las contraseñas no coinciden!",
    "updateSuccess": "Usuario actualizado exitosamente. ¡Por favor inicia sesión de nuevo!",
    "updateError": "Error al actualizar credenciales. ¿Proporcionaste la contraseña actual correcta?",
    "changeCredentialsTitle": "Cambiar credenciales",
    "changeCredentialsDescription": "El usuario y la contraseña pueden cambiarse por separado o simultáneamente. Ten en cuenta que se cerrará tu sesión después de cambiar las credenciales.",
    "currentUsername": "Usuario actual",
    "newUsername": "Nuevo usuario",
    "optional": "Opcional",
    "currentPassword": "Contraseña actual",
    "requiredIfUpdatingCredentials": "Obligatorio si actualizas credenciales",
    "newPassword": "Nueva contraseña",
    "confirmNewPassword": "Confirmar nueva contraseña",
    "save": "Guardar",
    "identityProvider": "tu proveedor de identidad",
    "oidcTitle": "Cuenta OpenID Connect",
    "oidcDescription": "Las credenciales de tu cuenta son administradas por tu proveedor de OpenID Connect. Para cambiar tu nombre de usuario, visita la página de configuración de tu proveedor e inicia sesión de nuevo.",
    "authenticatedViaOidc": "Autenticado vía OpenID Connect"
  },
  "logsPage": {
    "title": "Registros",
    "description": "Configurar nivel de registro, rotación de tamaño de registro, etc. Puedes descargar tus archivos de registro antiguos a continuación.",
    "chooseType": "Elige un tipo",
    "updated": "¡Configuración actualizada exitosamente!",
    "path": "Ruta",
    "setInConfig": "Establecido en config.toml",
    "notSet": "¡No establecido!",
    "level": "Nivel",
    "logLevel": "Nivel de registro",
    "maxSize": "Tamaño máximo",
    "maxBackups": "Máximo de respaldos"
  },
  "regexPlayground": {
    "title": "Playground de Regex",
    "description": "Playground de regex. Experimenta con tus filtros aquí. WIP.",
    "regexFilter": "Filtro RegExp",
    "linesToMatch": "Líneas a coincidir",
    "matches": "Coincidencias"
  },
  "apiKey": {
    "createTitle": "Crear clave API",
    "description": "Agregar nueva clave API.",
    "created": "Se agregó la clave API {{name}}",
    "deleted": "Se eliminó la clave API {{name}}",
    "name": "Nombre",
    "key": "Clave",
    "required": "Obligatorio",
    "closePanel": "Cerrar panel",
    "cancel": "Cancelar",
    "create": "Crear",
    "listTitle": "Claves API",
    "listDescription": "Administra tus claves API de autobrr aquí.",
    "addNew": "Agregar nueva",
    "noItems": "No hay claves API",
    "createCta": "Crear clave API",
    "removeTitle": "Eliminar clave API: {{name}}",
    "removeText": "¿Estás seguro de que quieres eliminar esta clave API? Esta acción no se puede deshacer.",
    "deleteKey": "Eliminar clave"
  },
  "irc": {
    "listTitle": "IRC",
    "listDescription": "Redes y canales IRC. Haz clic en una red para ver el estado del canal.",
    "addNew": "Agregar nueva",
    "networkHealthy": "Red saludable",
    "networkUnhealthy": "Red no saludable",
    "networkDisabled": "Red deshabilitada",
    "collapseTitle": "contraer",
    "expandTitle": "expandir",
    "collapse": "Contraer",
    "expand": "Expandir",
    "network": "Red",
    "noNetworks": "No hay redes",
    "noNetworksSubtitle": "Normalmente se configuran vía Indexadores",
    "addNewNetwork": "Agregar nueva red",
    "toggleSuccess": "{{name}} fue {{state}} exitosamente.",
    "enabledState": "habilitada",
    "disabledState": "deshabilitada",
    "connectedSince": "Conectado desde: {{time}}",
    "tlsSecured": "Asegurado con TLS",
    "tlsInsecure": "Inseguro, sin TLS",
    "channel": "Canal",
    "monitoringSince": "Monitoreando desde",
    "lastAnnounce": "Último anuncio",
    "monitoring": "monitoreando",
    "hide": "Ocultar",
    "view": "Ver",
    "networkDeleted": "La red {{name}} fue eliminada",
    "networkRestarted": "{{name}} fue reiniciada exitosamente",
    "removeNetworkTitle": "Eliminar red: {{name}}",
    "removeNetworkText": "¿Estás seguro de que quieres eliminar esta red? Esta acción no se puede deshacer.",
    "edit": "Editar",
    "restart": "Reiniciar",
    "delete": "Eliminar",
    "announceReprocessed": "¡Anuncio enviado a reprocesar!",
    "reprocessAnnounce": "Reprocesar anuncio",
    "options": "Opciones",
    "scrollOnNewMessage": "Desplazar al final con nuevo mensaje",
    "title": "Red",
    "addWarning": "¡AGREGA REDES VÍA INDEXADORES! SOLO USA ESTO SI ELIMINASTE REDES",
    "added": "Red IRC agregada. Por favor espera hasta 30 segundos para que la red se conecte.",
    "addFailed": "No se pudo agregar la red IRC",
    "updated": "{{name}} fue actualizada exitosamente",
    "deleted": "{{name}} fue eliminada.",
    "required": "Obligatorio",
    "name": "Nombre",
    "enabled": "Habilitada",
    "server": "Servidor",
    "serverPlaceholder": "Dirección: Ej irc.server.net",
    "port": "Puerto",
    "portPlaceholder": "Ej 6667",
    "tls": "TLS",
    "skipTls": "Omitir verificación TLS (inseguro)",
    "password": "Contraseña",
    "passwordHelp": "Contraseña de la red",
    "passwordUpdateHelp": "Contraseña de la red, no se usa comúnmente.",
    "nick": "Nick",
    "nickPlaceholderAdd": "nick del bot",
    "nickPlaceholderUpdate": "nick",
    "authAccount": "Cuenta de autenticación",
    "authAccountPlaceholder": "Cuenta de autenticación",
    "authPassword": "Contraseña de autenticación",
    "inviteCommand": "Comando de invitación",
    "channels": "Canales",
    "channelsDesc": "Canales a unirse.",
    "channelsUpdateDesc": "Los canales se agregan cuando configuras indexadores IRC. No edites a menos que sepas lo que estás haciendo.",
    "channelPassword": "Contraseña del canal",
    "remove": "Eliminar",
    "noChannels": "¡No hay canales!",
    "addChannel": "Agregar canal",
    "bouncer": "Bouncer (BNC)",
    "bouncerAddress": "Dirección del bouncer",
    "bouncerAddressHelp": "Dirección: Ej bouncer.server.net:6697",
    "botMode": "Modo Bot IRCv3",
    "proxy": "Proxy",
    "proxyDesc": "Establecer un proxy para conectar al servidor IRC.",
    "selectProxy": "Seleccionar proxy",
    "selectProxyPlaceholder": "Seleccionar un proxy",
    "identification": "Identificación",
    "identificationDesc": "Identificarse con SASL o NickServ. La mayoría de las redes soportan SASL pero algunas no.",
    "mechanism": "Mecanismo",
    "account": "Cuenta",
    "accountHelp": "Cuenta NickServ / SASL. Para nicks agrupados intenta con el principal.",
    "passwordSaslHelp": "Contraseña NickServ / SASL.",
    "chooseType": "Elige un tipo"
  },
  "releases": {
    "warningTitle": "Advertencia:",
    "warningBody": "Esta sección administra la eliminación del historial de lanzamientos. Los trabajos de limpieza automatizados se ejecutan en horarios programados, mientras que la eliminación manual permite una limpieza inmediata única. Ambas operaciones eliminan datos permanentemente y no se pueden deshacer.",
    "olderThan": "Más antiguo que",
    "olderThanDesc": "Antigüedad que deben tener los lanzamientos antes de la eliminación (Obligatorio para eliminación automatizada y manual)",
    "indexers": "Indexadores",
    "indexersDesc": "Filtro opcional (si no se selecciona ninguno, se aplica a todos los indexadores)",
    "releaseStatuses": "Estados de lanzamiento",
    "releaseStatusesDesc": "Filtro opcional (si no se selecciona ninguno, se aplica a todos los estados de lanzamiento)",
    "duplicateProfilesTitle": "Perfiles de lanzamientos duplicados",
    "duplicateProfilesDesc": "Administrar perfiles de duplicados.",
    "cleanupJobsTitle": "Trabajos de limpieza de lanzamientos",
    "cleanupJobsDesc": "Programar limpieza automática de lanzamientos antiguos con filtros personalizados.",
    "addNew": "Agregar nuevo",
    "edit": "Editar",
    "enabled": "Habilitado",
    "name": "Nombre",
    "lastRun": "Última ejecución",
    "nextRun": "Próxima ejecución",
    "runNow": "Ejecutar ahora",
    "delete": "Eliminar",
    "never": "Nunca",
    "deleteReleaseHistory": "Eliminar historial de lanzamientos",
    "deleteReleaseHistoryDesc": "Selecciona los criterios a continuación para eliminar permanentemente los registros del historial de lanzamientos que sean más antiguos que la edad elegida y opcionalmente coincidan con los indexadores y estados de lanzamiento seleccionados:",
    "removeReleases": "Eliminar lanzamientos",
    "invalidAge": "Por favor selecciona una edad válida.",
    "invalidAgeExample": "Por favor ingresa una edad válida. Por ejemplo, 6 meses o 1 año.",
    "allDeleted": "Todos los lanzamientos basados en los criterios fueron eliminados.",
    "olderThanDeleted": "Los lanzamientos más antiguos que {{duration}} fueron eliminados.",
    "allIndexers": "todos los indexadores",
    "selectedIndexers": "los indexadores elegidos",
    "removeCleanupJobTitle": "Eliminar trabajo de limpieza: {{name}}",
    "removeCleanupJobText": "¿Estás seguro de que quieres eliminar este trabajo de limpieza? Esta acción no se puede deshacer.",
    "cleanupJobToggled": "{{name}} {{state}}",
    "cleanupJobTriggered": "{{name}} ejecutado",
    "cleanupJobDeleted": "{{name}} eliminado",
    "cleanupJobEnabled": "habilitado",
    "cleanupJobDisabled": "deshabilitado",
    "duplicateFieldTitles": {
      "releaseName": "Nombre del lanzamiento",
      "hash": "Hash normalizado del nombre del lanzamiento. Usar con Nombre del lanzamiento para coincidencia exacta",
      "title": "Título parseado",
      "subTitle": "Subtítulo parseado como nombre del episodio",
      "group": "Grupo de lanzamiento",
      "year": "Año",
      "month": "Mes",
      "day": "Día",
      "source": "Fuente",
      "resolution": "Resolución",
      "codec": "Códec",
      "container": "Contenedor",
      "dynamicRange": "Rango dinámico (HDR,DV)",
      "audio": "Formatos de audio",
      "season": "Número de temporada",
      "episode": "Número de episodio",
      "website": "Sitio web/Servicio",
      "proper": "Scene proper",
      "repack": "Scene repack",
      "edition": "Edición (ej. Edición de Coleccionista) y Corte (ej. Corte del Director)",
      "language": "Idioma y región"
    },
    "noDuplicateProfiles": "No hay perfiles de lanzamientos duplicados",
    "addNewProfile": "Agregar nuevo perfil",
    "noCleanupJobs": "No hay trabajos de limpieza",
    "createCleanupSchedules": "Crear programaciones de limpieza automatizadas",
    "addNewJob": "Agregar nuevo trabajo",
    "removeReleasesText": "Estás a punto de {{scope}}.",
    "removeReleasesScopeAll": "eliminar todos los registros del historial de lanzamientos para {{indexers}}{{statuses}}",
    "removeReleasesScopeOlder": "eliminar permanentemente todos los registros del historial de lanzamientos más antiguos que {{duration}} para {{indexers}}{{statuses}}",
    "removeReleasesStatuses": " y con los siguientes estados de lanzamiento: {{statuses}}",
    "duration": {
      "allTime": "todo el tiempo",
      "hour1": "1 hora",
      "hours12": "12 horas",
      "day1": "1 día",
      "week1": "1 semana",
      "month1": "1 mes",
      "months3": "3 meses",
      "months6": "6 meses",
      "year1": "1 año",
      "invalid": "Duración inválida"
    }
  },
  "forms": {
    "downloadClient": {
      "remove": "Eliminar",
      "test": "Probar",
      "ok": "¡OK!",
      "error": "ERROR",
      "cancel": "Cancelar",
      "create": "Crear",
      "save": "Guardar",
      "added": "Se agregó el cliente",
      "addFailed": "No se pudo agregar el cliente",
      "updated": "{{name}} fue actualizado exitosamente",
      "deleted": "{{name}} fue eliminado.",
      "addTitle": "Agregar cliente",
      "addDescription": "Agregar cliente de descarga.",
      "editTitle": "Editar cliente",
      "editDescription": "Editar configuración del cliente de descarga.",
      "removeTitle": "Eliminar cliente de descarga",
      "removeText": "¿Estás seguro de que quieres eliminar este cliente de descarga? Esta acción no se puede deshacer.",
      "closePanel": "Cerrar panel",
      "name": "Nombre",
      "enabled": "Habilitado",
      "type": "Tipo",
      "host": "Host",
      "port": "Puerto",
      "tls": "TLS",
      "skipTls": "Omitir verificación TLS (inseguro)",
      "username": "Usuario",
      "password": "Contraseña",
      "apiKey": "Clave API",
      "authToken": "Token de autenticación",
      "basicAuth": "Autenticación básica",
      "auth": "Autenticación",
      "authType": "Tipo de autenticación",
      "selectAuthType": "Seleccionar tipo de autenticación",
      "authTypeTooltip": "En la mayoría de los casos debería ser Autenticación Básica, pero algunos proveedores usan Autenticación Digest.",
      "hostHelpDeluge": "Ej. client.domain.ltd, domain.ltd/client, domain.ltd:port",
      "hostHelpArr": "URL completa http(s)://domain.ltd y/o subdominio/subcarpeta",
      "hostHelpQbit": "Ej. http(s)://client.domain.ltd, http(s)://domain.ltd/qbittorrent, http://domain.ltd:port",
      "hostHelpPorla": "Ej. http(s)://client.domain.ltd, http(s)://domain.ltd/porla, http://domain.ltd:port",
      "hostHelpAria2": "Ej. http://localhost:6800, http(s)://domain.ltd/aria2",
      "rpcSecret": "Token RPC",
      "rpcSecretHelp": "El valor de --rpc-secret. Déjalo vacío si aria2 se ejecuta sin uno.",
      "hostHelpRTorrent": "Ej. http(s)://client.domain.ltd/RPC2, http(s)://domain.ltd/client, http(s)://domain.ltd/RPC2",
      "hostHelpTransmission": "Ej. http(s)://client.domain.ltd, http(s)://domain.ltd/transmission",
      "hostHelpSabnzbd": "Ej. http://ip:port o https://url.com/sabnzbd",
      "hostHelpNzbget": "Ej. http://localhost:6789",
      "daemonPort": "Puerto del daemon",
      "webUiPortQbit": "Puerto WebUI para qBittorrent",
      "transmissionPort": "Puerto para Transmission",
      "sabnzbdPort": "Puerto para SABnzbd",
      "guidesDeluge": "Consulta las guías sobre cómo conectar a Deluge para varios tipos de servidor en nuestra documentación.",
      "guidesArr": "Consulta las guías sobre cómo conectar a la suite *arr para varios tipos de servidor en nuestra documentación.",
      "guidesQbit": "Consulta las guías sobre cómo conectar a qBittorrent para varios tipos de servidor en nuestra documentación.",
      "guidesRTorrent": "Consulta las guías sobre cómo conectar a rTorrent para varios tipos de servidor en nuestra documentación.",
      "guidesTransmission": "Consulta las guías sobre cómo conectar a Transmission para varios tipos de servidor en nuestra documentación.",
      "guidesSabnzbd": "Consulta nuestras guías sobre cómo conectar a SABnzbd para varios tipos de servidor en nuestra documentación.",
      "dedicatedServers": "Servidores dedicados:",
      "sharedSeedboxProviders": "Proveedores de seedbox compartidos:",
      "rulesTitle": "Reglas",
      "rulesDescriptionBasic": "Administrar descargas máximas.",
      "rulesDescriptionAdvanced": "Administrar descargas máximas, etc.",
      "maxActiveDownloads": "Descargas activas máximas",
      "maxActiveDownloadsTooltip": "Limitar la cantidad de descargas activas (0 es ilimitado), para dar el máximo de ancho de banda y disco a las descargas.",
      "seeRecommendations": "Ver recomendaciones para varios tipos de servidor aquí:",
      "downloadClientTitle": "Cliente de descarga",
      "downloadClientDescription": "Anular el cliente de descarga a usar. También puede anularse por Acción de Filtro.",
      "clientName": "Nombre del cliente",
      "clientNameTooltip": "Especifica qué cliente debe usar el arr por defecto. Se puede anular por acción de filtro.",
      "clientIdDeprecated": "ID del cliente OBSOLETO",
      "clientIdDeprecatedTooltip": "OBSOLETO: Usa el campo Nombre del cliente en su lugar.",
      "ignoreSlowTorrents": "Ignorar torrents lentos",
      "ignoreCondition": "Condición de ignorar",
      "selectIgnoreCondition": "Seleccionar condición de ignorar",
      "ignoreConditionTooltip": "Elige si respetar o ignorar la configuración de Descargas activas máximas antes de verificar los umbrales de velocidad.",
      "downloadSpeedThreshold": "Umbral de velocidad de descarga",
      "uploadSpeedThreshold": "Umbral de velocidad de subida",
      "speedThresholdPlaceholder": "en KB/s",
      "downloadSpeedThresholdHelp": "Si la velocidad de descarga está por debajo de esto cuando se alcanza el máximo de descargas activas, descargar de todos modos. KB/s",
      "uploadSpeedThresholdHelp": "Si la velocidad de subida está por debajo de esto cuando se alcanza el máximo de descargas activas, descargar de todos modos. KB/s"
    },
    "feed": {
      "title": "Feed",
      "updated": "{{name}} fue actualizado exitosamente",
      "deleted": "{{name}} fue eliminado.",
      "testOk": "¡Prueba de {{name}} OK!",
      "name": "Nombre",
      "type": "Tipo",
      "enabled": "Habilitado",
      "warningTitle": "¡Advertencia: Los indexadores podrían banearte por un intervalo demasiado bajo!",
      "warningText": "Lee las reglas del indexador.",
      "url": "URL",
      "torznabUrlHelp": "URL de Torznab. Usa solo la URL sin parámetros extra.",
      "newznabUrlHelp": "URL de Newznab. Usa solo la URL sin parámetros extra.",
      "rssUrlHelp": "URL RSS",
      "urlFormatTitle": "Prowlarr y Jackett tienen formatos diferentes:",
      "prowlarr": "Prowlarr",
      "jackett": "Jackett",
      "downloadType": "Tipo de descarga",
      "apiKey": "Clave API",
      "skipTls": "Omitir verificación TLS (inseguro)",
      "refreshInterval": "Intervalo de actualización",
      "refreshIntervalHelp": "Minutos. Recomendado 15-30. Demasiado bajo puede arriesgar un baneo.",
      "refreshTimeout": "Tiempo de espera de actualización",
      "refreshTimeoutHelp": "Segundos a esperar antes de cancelar la actualización.",
      "maxAge": "Antigüedad máxima",
      "maxAgeHelp": "Antigüedad máxima del contenido del feed en segundos. Usa 0 para deshabilitar el filtro de antigüedad y procesar todos los elementos.",
      "cookie": "Cookie",
      "cookieHelp": "No se usa comúnmente",
      "userAgent": "User-Agent",
      "userAgentHelp": "User-Agent personalizado para solicitudes RSS. Usar cuando las cookies de Cloudflare requieren un User-Agent coincidente (por ejemplo de byparr)",
      "categoriesTitle": "Categorías",
      "categoriesDescription": "Obtener categorías disponibles y seleccionar qué incluir.",
      "fetch": "Obtener",
      "fetching": "Obteniendo",
      "refetch": "Volver a obtener",
      "fetchFailed": "Error al obtener categorías",
      "noCategories": "No se encontraron categorías.",
      "fetchToSelect": "Obtener categorías para seleccionar."
    },
    "list": {
      "added": "¡Lista agregada!",
      "addFailed": "No se pudo agregar la lista",
      "updated": "{{name}} fue actualizada exitosamente",
      "deleted": "{{name}} fue eliminada.",
      "name": "Nombre",
      "type": "Tipo",
      "enabled": "Habilitada",
      "filters": "Filtros",
      "addTitle": "Agregar lista",
      "updateTitle": "Actualizar lista",
      "description": "Actualizar filtros automáticamente desde listas y arrs.",
      "closePanel": "Cerrar panel",
      "chooseType": "Elige un tipo",
      "chooseClient": "Elige un cliente",
      "selectClient": "Seleccionar cliente",
      "selectClientLabel": "Seleccionar cliente",
      "filtersDescription": "Selecciona filtros a actualizar para esta lista.",
      "cancel": "Cancelar",
      "remove": "Eliminar",
      "save": "Guardar",
      "saving": "Guardando..",
      "selectSomeItems": "Seleccionar...",
      "allItemsSelected": "Todos los elementos están seleccionados",
      "selectAll": "Seleccionar todo",
      "search": "Buscar",
      "noOptions": "Sin opciones",
      "removeTitle": "Eliminar {{name}}",
      "removeText": "¿Estás seguro de que quieres eliminar {{name}}? Esta acción no se puede deshacer.",
      "required": "Obligatorio",
      "settingsLegend": "Configuración",
      "source": "Fuente",
      "sourceList": "Lista de fuentes",
      "arrSourceDescription": "Actualizar filtros desde títulos en Radarr, Sonarr, Lidarr, Readarr o Whisparr.",
      "traktSourceDescription": "Usar una lista de Trakt o una de las listas predeterminadas alojadas por autobrr.",
      "anilistSourceDescription": "Usar una lista de AniList de una de las listas predeterminadas alojadas por autobrr.",
      "plaintextSourceDescription": "Usar una lista de texto plano con un elemento por línea.",
      "steamSourceDescription": "Seguir listas de deseos de Steam.",
      "metacriticSourceDescription": "Usar una lista de Metacritic o una de las listas predeterminadas alojadas por autobrr.",
      "mdblistSourceDescription": "Usar una lista de MDBList o una de las listas predeterminadas alojadas por autobrr.",
      "listUrl": "URL de la lista",
      "traktHelp": "Listas predeterminadas de Trakt. Anula con las tuyas.",
      "traktApiKey": "Clave API",
      "traktApiKeyHelp": "Clave API de Trakt. Requerida para listas privadas.",
      "matchRelease": "Coincidir lanzamiento",
      "matchReleaseDesc": "Usar campo Coincidir lanzamientos. Usa el campo Películas/Series por defecto.",
      "includeUnmonitored": "Incluir no monitoreados",
      "includeUnmonitoredDesc": "Por defecto solo se filtran los títulos monitoreados.",
      "includeAlternateTitles": "Incluir títulos alternativos",
      "includeAlternateTitlesDesc": "Incluir títulos alternativos en el filtro.",
      "skipCleanSanitize": "Omitir limpieza y sanitización y usar la lista tal cual",
      "skipCleanSanitizeDesc": "Por defecto, los títulos se sanitizan automáticamente y se verifican caracteres inusuales.",
      "tagsIncluded": "Etiquetas incluidas",
      "tagsExcluded": "Etiquetas excluidas",
      "metacriticHelp": "Listas de Metacritic. Anula con las tuyas.",
      "mdblistHelp": "Listas de MDBLists.com. Anula con las tuyas.",
      "includeYear": "Incluir año",
      "includeYearDesc": "Incluir el año de lanzamiento en el filtro para películas. Requiere Coincidir lanzamientos. Ejemplo: Título?Pelicula?2024*",
      "plaintextUrlHelp": "URL a un archivo de texto plano con un elemento por línea",
      "plaintextUrlPlaceholder": "https://ejemplo.com/lista.txt",
      "plaintextTooltip1": "Las listas de texto plano pueden leer tanto de URLs HTTP como de archivos locales en disco.",
      "plaintextTooltipRemote": "Remoto: https://servicio.com/archivo.txt",
      "plaintextTooltipLocal": "Local: file:///home/usuario/archivo.txt",
      "url": "URL",
      "steamUrlHelp": "URL de lista de deseos de Steam",
      "steamUrlPlaceholder": "https://store.steampowered.com/wishlist/id/USUARIO/wishlistdata"
    },
    "proxy": {
      "title": "Proxy",
      "addTitle": "Agregar proxy",
      "addDescription": "Agregar proxy para usar con Indexadores o IRC.",
      "added": "¡Proxy agregado!",
      "addFailed": "No se pudo agregar el proxy",
      "updated": "¡Proxy {{name}} actualizado!",
      "updateFailed": "No se pudo actualizar el proxy",
      "deleted": "Proxy {{name}} fue eliminado.",
      "name": "Nombre",
      "closePanel": "Cerrar panel",
      "enabled": "Habilitado",
      "proxyType": "Tipo de proxy",
      "proxyTypeTooltip": "Tipo de proxy. Comúnmente SOCKS5.",
      "proxyTypeHelp": "Generalmente SOCKS5",
      "addr": "Dirección",
      "addrHelp": "Dirección: scheme://ip:port o scheme://domain",
      "user": "Usuario",
      "userHelp": "autenticación: usuario",
      "pass": "Contraseña",
      "passHelp": "autenticación: contraseña",
      "test": "Probar",
      "cancel": "Cancelar",
      "save": "Guardar"
    },
    "apiKey": {
      "createTitle": "Crear clave API",
      "description": "Agregar nueva clave API.",
      "created": "Se agregó la clave API {{name}}",
      "deleted": "Se eliminó la clave API {{name}}",
      "name": "Nombre",
      "key": "Clave",
      "required": "Obligatorio",
      "closePanel": "Cerrar panel",
      "cancel": "Cancelar",
      "create": "Crear",
      "listTitle": "Claves API",
      "listDescription": "Administra tus claves API de autobrr aquí.",
      "addNew": "Agregar nueva",
      "noItems": "No hay claves API",
      "createCta": "Crear clave API",
      "removeTitle": "Eliminar clave API: {{name}}",
      "removeText": "¿Estás seguro de que quieres eliminar esta clave API? Esta acción no se puede deshacer.",
      "deleteKey": "Eliminar clave"
    },
    "notification": {
      "settings": "Configuración",
      "settingsDescDiscordPrefix": "Crea una ",
      "settingsDescDiscordSuffix": " en tu servidor.",
      "discordWebhookIntegration": "integración de webhook",
      "settingsDescNotifiarr": "Habilita la integración de autobrr y opcionalmente crea una nueva clave API.",
      "settingsDescLunasea1": "LunaSea ofrece notificaciones en todos los dispositivos vinculados a tu cuenta (Basado en usuario) o a un solo dispositivo sin cuenta, usando un webhook único por dispositivo (Basado en dispositivo).",
      "settingsDescLunasea2Prefix": "Lee la ",
      "settingsDescLunasea2Suffix": ".",
      "lunaseaDocs": "documentación de LunaSea",
      "settingsDescTelegramPrefix": "Lee cómo ",
      "settingsDescTelegramSuffix": ".",
      "createBot": "crear un bot",
      "settingsDescPushoverPrefix": "Registra una nueva ",
      "settingsDescPushoverSuffix": " y agrega su Token API aquí.",
      "pushoverApplication": "aplicación",
      "eventSounds": "Sonidos de eventos",
      "eventSoundsDesc": "Establecer sonidos personalizados por evento",
      "settingsDescWebhook": "Enviar una carga útil JSON genérica de autobrr a una URL de webhook definida por el usuario.",
      "added": "¡Notificación agregada!",
      "addFailed": "No se pudo agregar la notificación",
      "updated": "{{name}} fue actualizada exitosamente",
      "deleted": "{{name}} fue eliminada.",
      "required": "Obligatorio",
      "addTitle": "Agregar notificaciones",
      "addDescription": "Activar notificaciones en diferentes eventos.",
      "title": "Notificación",
      "name": "Nombre",
      "type": "Tipo",
      "enabled": "Habilitada",
      "chooseType": "Elige un tipo",
      "closePanel": "Cerrar panel",
      "globalEvents": "Eventos globales",
      "globalEventsDesc": "Selecciona eventos predeterminados que se activan globalmente. Estos pueden anularse por filtro. Deja todos sin marcar para usar este servicio solo para notificaciones específicas de filtro.",
      "perFilterEvents": "Eventos por filtro",
      "perFilterEventsDesc": "Esta notificación se usa en estos filtros.",
      "notUsedInFilters": "No se usa en ningún filtro",
      "muted": "Silenciada",
      "test": "Probar",
      "cancel": "Cancelar",
      "save": "Guardar",
      "notificationsLegend": "Notificaciones",
      "defaultTone": "Predeterminado (tono predeterminado del usuario)",
      "webhookUrl": "URL del webhook",
      "discordWebhookPlaceholder": "https://discordapp.com/api/webhooks/xx/xx",
      "discordWebhookHelp": "URL del webhook del canal de Discord",
      "notifiarrApiKey": "Clave API",
      "notifiarrApiKeyHelp": "Clave API de Notifiarr",
      "lunaseaWebhookPlaceholder": "https://notify.lunasea.app/v1/custom/user/TOKEN",
      "lunaseaWebhookHelp": "URL del webhook de LunaSea",
      "botToken": "Token del bot",
      "botTokenHelp": "Token del bot",
      "chatId": "ID del chat",
      "chatIdHelp": "ID del chat",
      "messageThreadId": "ID del hilo de mensaje",
      "messageThreadIdHelp": "Hilo de mensaje (tema) de un Supergrupo",
      "telegramProxy": "Proxy de API de Telegram",
      "telegramProxyHelp": "Dominio de proxy inverso para api.telegram.org. Solo necesario si tu red bloquea la API de Telegram.",
      "telegramProxyPlaceholder": "http(s)://ip:port",
      "sender": "Remitente",
      "senderHelp": "Nombre de remitente personalizado mostrado en la parte superior de una notificación",
      "senderPlaceholder": "autobrr",
      "apiToken": "Token API",
      "apiTokenHelp": "Token API",
      "userKey": "Clave de usuario",
      "userKeyHelp": "Clave de usuario",
      "priority": "Prioridad",
      "pushoverPriorityHelp": "-2, -1, 0 (predeterminado), 1, o 2",
      "gotifyUrl": "URL de Gotify",
      "gotifyUrlHelp": "URL de Gotify (sin /message)",
      "gotifyUrlPlaceholder": "https://algun.servidor.gotify.com",
      "applicationToken": "Token de aplicación",
      "applicationTokenHelp": "Token de aplicación",
      "ntfyUrl": "URL de NTFY",
      "ntfyUrlHelp": "URL de NTFY",
      "ntfyUrlPlaceholder": "https://ntfy.sh/mitema",
      "username": "Usuario",
      "usernameHelp": "Usuario",
      "password": "Contraseña",
      "passwordHelp": "Contraseña",
      "accessToken": "Token de acceso",
      "accessTokenHelp": "Token de acceso. Usa esto o Usuario + contraseña",
      "tags": "Tags",
      "ntfyTagsHelp": "Etiquetas/iconos separados por comas para notificaciones de ntfy",
      "ntfyTagsPlaceholder": "download,arr,white_check_mark",
      "ntfyPriorityHelp": "Máx 5, 4, 3 (predeterminado), 2, 1 Mín",
      "url": "URL",
      "urlHelp": "URL",
      "shoutrrrDocsPrefix": "Ver documentación completa ",
      "shoutrrrServices": "Servicios",
      "shoutrrrUrlPlaceholder": "smtp://usuario:contraseña@host:puerto/?from=direccionOrigen&to=destinatario1",
      "httpMethod": "Método HTTP",
      "httpMethodDefault": "POST (predeterminado)",
      "httpMethodTooltip": "Método HTTP para la solicitud del webhook. Por defecto POST.",
      "webhookPlaceholder": "https://ejemplo.com/webhook",
      "customHeaders": "Cabeceras personalizadas",
      "customHeadersHelp": "Pares KEY=valor separados por comas (ej., Authorization=Bearer token,X-Custom=valor)",
      "customHeadersPlaceholder": "Authorization=Bearer token,X-Custom-Header=valor"
    },
    "irc": {
      "listTitle": "IRC",
      "listDescription": "Redes y canales IRC. Haz clic en una red para ver el estado del canal.",
      "addNew": "Agregar nueva",
      "networkHealthy": "Red saludable",
      "networkUnhealthy": "Red no saludable",
      "networkDisabled": "Red deshabilitada",
      "collapseTitle": "contraer",
      "expandTitle": "expandir",
      "collapse": "Contraer",
      "expand": "Expandir",
      "network": "Red",
      "noNetworks": "No hay redes",
      "noNetworksSubtitle": "Normalmente se configuran vía Indexadores",
      "addNewNetwork": "Agregar nueva red",
      "toggleSuccess": "{{name}} fue {{state}} exitosamente.",
      "enabledState": "habilitada",
      "disabledState": "deshabilitada",
      "connectedSince": "Conectado desde: {{time}}",
      "tlsSecured": "Asegurado con TLS",
      "tlsInsecure": "Inseguro, sin TLS",
      "channel": "Canal",
      "monitoringSince": "Monitoreando desde",
      "lastAnnounce": "Último anuncio",
      "monitoring": "monitoreando",
      "hide": "Ocultar",
      "view": "Ver",
      "networkDeleted": "La red {{name}} fue eliminada",
      "networkRestarted": "{{name}} fue reiniciada exitosamente",
      "removeNetworkTitle": "Eliminar red: {{name}}",
      "removeNetworkText": "¿Estás seguro de que quieres eliminar esta red? Esta acción no se puede deshacer.",
      "edit": "Editar",
      "restart": "Reiniciar",
      "delete": "Eliminar",
      "announceReprocessed": "¡Anuncio enviado a reprocesar!",
      "reprocessAnnounce": "Reprocesar anuncio",
      "options": "Opciones",
      "scrollOnNewMessage": "Desplazar al final con nuevo mensaje",
      "title": "Red",
      "addWarning": "¡AGREGA REDES VÍA INDEXADORES! SOLO USA ESTO SI ELIMINASTE REDES",
      "added": "Red IRC agregada. Por favor espera hasta 30 segundos para que la red se conecte.",
      "addFailed": "No se pudo agregar la red IRC",
      "updated": "{{name}} fue actualizada exitosamente",
      "deleted": "{{name}} fue eliminada.",
      "required": "Obligatorio",
      "name": "Nombre",
      "enabled": "Habilitada",
      "server": "Servidor",
      "serverPlaceholder": "Dirección: Ej irc.server.net",
      "port": "Puerto",
      "portPlaceholder": "Ej 6667",
      "tls": "TLS",
      "skipTls": "Omitir verificación TLS (inseguro)",
      "password": "Contraseña",
      "passwordHelp": "Contraseña de la red",
      "passwordUpdateHelp": "Contraseña de la red, no se usa comúnmente.",
      "nick": "Nick",
      "nickPlaceholderAdd": "nick del bot",
      "nickPlaceholderUpdate": "nick",
      "authAccount": "Cuenta de autenticación",
      "authAccountPlaceholder": "Cuenta de autenticación",
      "authPassword": "Contraseña de autenticación",
      "inviteCommand": "Comando de invitación",
      "channels": "Canales",
      "channelsDesc": "Canales a unirse.",
      "channelsUpdateDesc": "Los canales se agregan cuando configuras indexadores IRC. No edites a menos que sepas lo que estás haciendo.",
      "channelPassword": "Contraseña del canal",
      "remove": "Eliminar",
      "noChannels": "¡No hay canales!",
      "addChannel": "Agregar canal",
      "bouncer": "Bouncer (BNC)",
      "bouncerAddress": "Dirección del bouncer",
      "bouncerAddressHelp": "Dirección: Ej bouncer.server.net:6697",
      "botMode": "Modo Bot IRCv3",
      "proxy": "Proxy",
      "proxyDesc": "Establecer un proxy para conectar al servidor IRC.",
      "selectProxy": "Seleccionar proxy",
      "selectProxyPlaceholder": "Seleccionar un proxy",
      "identification": "Identificación",
      "identificationDesc": "Identificarse con SASL o NickServ. La mayoría de las redes soportan SASL pero algunas no.",
      "mechanism": "Mecanismo",
      "account": "Cuenta",
      "accountHelp": "Cuenta NickServ / SASL. Para nicks agrupados intenta con el principal.",
      "passwordSaslHelp": "Contraseña NickServ / SASL.",
      "chooseType": "Elige un tipo"
    },
    "indexer": {
      "title": "Indexador",
      "addTitle": "Agregar indexador",
      "addDescription": "Agregar indexador.",
      "added": "Se agregó el indexador",
      "addFailed": "No se pudo agregar el indexador",
      "updated": "{{name}} fue actualizado exitosamente",
      "deleted": "{{name}} fue eliminado.",
      "indexer": "Indexador",
      "chooseIndexer": "Elige un indexador",
      "required": "Obligatorio",
      "defaultValueValidation": "Valor predeterminado, por favor edita",
      "enabled": "Habilitado",
      "baseUrl": "URL base",
      "baseUrlHelp": "Anular URL base si está bloqueada por tu ISP.",
      "cancel": "Cancelar",
      "save": "Guardar",
      "closePanel": "Cerrar panel",
      "ircTitle": "IRC",
      "ircDesc": "Las redes y canales se configuran automáticamente en segundo plano.",
      "torznabTitle": "Torznab",
      "torznabDesc": "Feed Torznab",
      "newznabTitle": "Newznab",
      "newznabDesc": "Feed Newznab",
      "rssTitle": "RSS",
      "rssDesc": "Feed RSS",
      "settingsIrcTitle": "IRC",
      "settingsIrcDesc": "Las redes y canales se configuran automáticamente en segundo plano.",
      "ircGuideTooltip": "Por favor lee nuestra guía de IRC si no estás familiarizado con IRC.",
      "name": "Nombre",
      "url": "URL",
      "torznabUrlHelp": "URL de Torznab. Usa solo la URL sin parámetros extra.",
      "newznabUrlHelp": "URL de Newznab. Usa solo la URL sin parámetros extra.",
      "urlFormatTitle": "Prowlarr y Jackett tienen formatos diferentes:",
      "prowlarr": "Prowlarr",
      "jackett": "Jackett",
      "apiKey": "Clave API",
      "downloadType": "Tipo de descarga",
      "downloadTypeTooltip": "Algunos feeds necesitan ser forzados a Magnet.",
      "downloadTypeHelp": "Establecer a Torrent o Magnet dependiendo del indexador.",
      "downloadTypeTooltip2": "Algunos feeds necesitan ser forzados a Magnet.",
      "categoriesTitle": "Categorías",
      "categoriesDescription": "Obtener categorías disponibles y seleccionar qué incluir.",
      "fetch": "Obtener",
      "fetching": "Obteniendo",
      "refetch": "Volver a obtener",
      "fetchFailed": "Error al obtener categorías",
      "fetchNeedsUrl": "Ingresa una URL para obtener categorías",
      "noCategories": "No se encontraron categorías.",
      "fetchToSelect": "Obtener categorías para seleccionar.",
      "testApi": "Probar API",
      "testApiSuccess": "¡Prueba de API exitosa!",
      "ok": "¡OK!",
      "error": "ERROR",
      "externalIdentifier": "Identificador externo",
      "externalIdentifierHelp": "Identificador externo para ARRs. Si usas Prowlarr establece como: {{name}} (Prowlarr)",
      "externalIdentifierTooltip1": "Identificador externo para uso con ARRs para obtener funciones como límites de siembra.",
      "externalIdentifierTooltip2": "Esto necesita coincidir con el nombre del indexador en tu ARR. Si usas Prowlarr probablemente será \"{{name}} (Prowlarr)\"",
      "secretFieldTooltip": "Este campo no acepta una URL completa. Solo usa cadenas alfanuméricas como uqcdi67cibkx3an8cmdm.",
      "proxy": "Proxy",
      "proxyDesc": "Establecer un proxy para descargas de archivos .torrent y feeds.",
      "selectProxy": "Seleccionar proxy",
      "selectProxyPlaceholder": "Seleccionar un proxy",
      "chooseType": "Elige un tipo",
      "editFeeds": "Editar feeds RSS en Configuración -> Feeds"
    },
    "releaseProfile": {
      "title": "Perfil de duplicados",
      "added": "Se agregó el perfil",
      "addFailed": "No se pudo agregar el perfil",
      "deleted": "¡Se eliminó el perfil {{name}}!",
      "fields": {
        "name": "Nombre",
        "releaseName": "Nombre del lanzamiento",
        "hash": "Hash",
        "title": "Título",
        "subTitle": "Subtítulo",
        "year": "Año",
        "month": "Mes",
        "day": "Día",
        "source": "Fuente",
        "resolution": "Resolución",
        "codec": "Códec",
        "container": "Contenedor",
        "dynamicRange": "Rango dinámico",
        "audio": "Audio",
        "group": "Grupo",
        "season": "Temporada",
        "episode": "Episodio",
        "website": "Sitio web/Servicio",
        "proper": "Proper",
        "repack": "Repack",
        "edition": "Edición",
        "hybrid": "Versión híbrida",
        "language": "Idioma"
      },
      "descriptions": {
        "releaseName": "Nombre completo del lanzamiento",
        "hash": "Hash normalizado del nombre del lanzamiento. Usar con Nombre del lanzamiento para coincidencia exacta",
        "title": "Título parseado",
        "subTitle": "Subtítulo parseado como nombre del episodio",
        "dailyReleases": "Para lanzamientos diarios",
        "group": "Grupo de lanzamiento",
        "website": "Servicios como AMZN/HULU/NF",
        "dynamicRange": "Rango dinámico (HDR,DV etc)",
        "edition": "Edición y corte",
        "language": "Idioma y región"
      }
    },
    "cleanupJob": {
      "title": "Trabajo de limpieza",
      "created": "Trabajo de limpieza creado",
      "createFailed": "No se pudo crear el trabajo",
      "updated": "Trabajo actualizado",
      "updateFailed": "No se pudo actualizar el trabajo",
      "deleted": "{{name}} eliminado",
      "enableDesc": "Habilitar este trabajo de limpieza",
      "namePlaceholder": "Limpieza semanal",
      "schedule": "Programación (Cron)",
      "schedulePlaceholder": "0 3 * * *",
      "scheduleHelp": "Expresión cron. Ejemplos: '0 3 * * *' = diario 3 AM, '0 */6 * * *' = cada 6 horas",
      "olderThan": "Más antiguo que",
      "olderThanPlaceholder": "30",
      "olderThanHelp": "Eliminar lanzamientos más antiguos que esta duración",
      "indexersOptional": "Indexadores (Opcional)",
      "statusesOptional": "Estados (Opcional)",
      "leaveEmptyIndexers": "Dejar vacío para aplicar a todos los indexadores",
      "leaveEmptyStatuses": "Dejar vacío para aplicar a todos los estados",
      "executionHistory": "Historial de ejecución",
      "lastRun": "Última ejecución:",
      "status": "Estado:"
    }
  },
  "listScreens": {
    "common": {
      "enabled": "Habilitado",
      "name": "Nombre",
      "type": "Tipo",
      "edit": "Editar",
      "addNew": "Agregar nuevo",
      "unknownError": "Ocurrió un error desconocido"
    },
    "downloadClients": {
      "title": "Clientes de descarga",
      "description": "Administrar clientes de descarga.",
      "host": "Host",
      "noItems": "No hay clientes de descarga",
      "addNewItem": "Agregar nuevo cliente",
      "toggleSuccess": "{{name}} fue {{state}} exitosamente.",
      "enabledState": "habilitado",
      "disabledState": "deshabilitado"
    },
    "notifications": {
      "title": "Notificaciones",
      "description": "Configurar servicios de notificación y sus activadores de eventos globales.",
      "events": "Eventos",
      "filters": "Filtros",
      "noItems": "No hay notificaciones",
      "addNewItem": "Crear nueva notificación",
      "infoTitle": "Anulaciones por filtro:",
      "infoBody": "Puedes anular esta configuración global para filtros específicos en la pestaña de Notificaciones de cada filtro. Los eventos globales son opcionales - puedes crear servicios de notificación sin ningún evento y configurarlos solo a nivel de filtro. Los eventos del sistema (IRC desconectado/reconectado, actualizaciones de la app) siempre usan la configuración global.",
      "toggleSuccess": "{{name}} fue {{state}} exitosamente.",
      "enabledState": "habilitada",
      "disabledState": "deshabilitada"
    },
    "indexers": {
      "title": "Indexadores",
      "description": "Configuración de indexadores para indexadores basados en IRC, RSS, Newznab y Torznab.",
      "descriptionGeneric": "Los feeds genéricos RSS/Newznab/Torznab se pueden agregar aquí seleccionando uno de los indexadores <strong>Genéricos</strong>.",
      "implementation": "Implementación",
      "noItems": "No hay indexadores",
      "addNewItem": "Agregar nuevo indexador",
      "updated": "{{name}} fue actualizado exitosamente"
    },
    "proxies": {
      "title": "Proxies",
      "description": "Proxies que se pueden usar con Indexadores, feeds e IRC.",
      "noItems": "No hay proxies",
      "addNewItem": "Agregar nuevo proxy",
      "toggleSuccess": "Proxy {{name}} fue {{state}} exitosamente.",
      "toggleError": "No se pudo actualizar el estado del proxy",
      "enabledState": "habilitado",
      "disabledState": "deshabilitado"
    },
    "lists": {
      "title": "Listas",
      "description": "Las listas pueden actualizar automáticamente tus filtros desde arrs u otras fuentes.",
      "filters": "Filtros",
      "noItems": "No hay listas",
      "addNewItem": "Agregar nueva lista",
      "toggleSuccess": "Lista {{name}} fue {{state}} exitosamente.",
      "toggleError": "No se pudo actualizar el estado de la lista",
      "refreshSuccess": "Lista {{name}} fue obtenida exitosamente.",
      "refreshError": "Error al actualizar {{name}}. Error: {{error}}",
      "deleted": "{{name}} fue eliminada.",
      "removeTitle": "Eliminar lista: {{name}}",
      "removeText": "¿Estás seguro de que quieres eliminar esta lista? Esta acción no se puede deshacer.",
      "copyId": "Copiar ID de lista",
      "copyIdSuccess": "ID de lista {{id}} copiado al portapapeles.",
      "refresh": "Actualizar",
      "delete": "Eliminar",
      "enabledState": "habilitada",
      "disabledState": "deshabilitada"
    },
    "feeds": {
      "title": "Feeds",
      "description": "Administrar feeds RSS, Newznab y Torznab.",
      "lastRun": "Última ejecución",
      "nextRun": "Próxima ejecución",
      "noItems": "No hay feeds",
      "noItemsDesc": "Configurar vía indexadores",
      "toggleSuccess": "{{name}} fue {{state}} exitosamente.",
      "enabledState": "habilitado",
      "disabledState": "deshabilitado",
      "deleted": "Feed {{name}} fue eliminado",
      "cacheCleared": "¡Se limpió la caché del feed {{name}}!",
      "forceRunSuccess": "Feed {{name}} fue ejecutado forzadamente exitosamente.",
      "forceRunError": "Error al ejecutar forzadamente {{name}}. Error: {{error}}",
      "removeTitle": "Eliminar feed: {{name}}",
      "removeText": "¿Estás seguro de que quieres eliminar este feed? Esta acción no se puede deshacer.",
      "removeCacheTitle": "Eliminar caché del feed: {{name}}",
      "removeCacheText": "¿Estás seguro de que quieres eliminar la caché del feed? Esta acción no se puede deshacer.",
      "forceRunTitle": "Forzar ejecución del feed: {{name}}",
      "forceRunText": "¿Estás seguro de que quieres forzar la ejecución del feed {{name}}? Respetar las reglas de intervalo RSS es crucial para evitar posibles baneos de IP.",
      "toggle": "Alternar",
      "forceRun": "Forzar ejecución",
      "viewLatestRun": "Ver última ejecución",
      "clearCache": "Limpiar caché del feed",
      "clearCacheTitle": "Limpiar manualmente toda la caché del feed",
      "delete": "Eliminar"
    }
  }
}
